export const runStatus: { [key: string]: TRunStatus } = {
  FAILED: 'failed',
  COMPLETED: 'completed',
  RUNNING: 'running',
  CACHED: 'cached',
};
